import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from "react-redux";
import { getisAuthenticated } from "./modules/reducers"
import About from './screens/About';
import Cart from './screens/Cart';
import Checkout from './screens/Checkout';
import Home from './screens/Home';
import ReturnPolicy from './screens/ReturnPolicy';
import Shop from './screens/Shop';
import ShoppingPolicy from './screens/ShippingPolicy';
import ShopSingle from './screens/ShopSingle';
import Thankyou from './screens/Thankyou';
import Contact from './screens/Contact';
import Login from './screens/Login';
import Orders from './screens/Orders';
import schoolProducts from './screens/schoolProducts';
import ViewOrderDetails from './screens/ViewOrderDetails';
import MyStudents from './screens/MyStudents';
// import Profile from './screens/Profile';
import TermsAndConditions from './screens/TermsAndConditions';
import Pricing from './screens/Pricing';
import PrivacyPolicy from './screens/PrivacyPolicy';
import SelectSchool from './screens/SelectSchool';
import UniformOrder from './screens/UniformOrder';

export class App extends Component {
  constructor() {
    super();
    this.state = {
    }
  }
  render() {
    return (
      <div>
        <BrowserRouter basename={'/edukart/'}>
          <div>
            <Switch>
              <Route path="/" component={Home} exact />
              <Route path="/about" component={About} exact />
              <Route path="/shippingPolicy" component={ShoppingPolicy} exact />
              <Route path="/returnPolicy" component={ReturnPolicy} exact />
              <Route path="/pricing" component={Pricing} exact />
              <Route path="/privacyPolicy" component={PrivacyPolicy} exact />
              <Route path="/termsAndConditions" component={TermsAndConditions} exact />
              <Route path="/contact" component={Contact} exact />
              <Route path="/login" component={Login} exact />
              <Route path="/selectSchool" component={SelectSchool} exact />
              <Route path="/school/:sname" component={Shop} exact />
              <Route path="/schoolProducts" component={schoolProducts} exact />
              <Route path="/uniformOrder" component={UniformOrder} exact />
              <Route path="/shopSingle" component={ShopSingle} exact />
              <Route path="/cart" component={Cart} exact />
              <Route path="/checkout" component={Checkout} exact />
              <Route path="/thankyou" component={Thankyou} exact />
              {
                this.props.isAuthenticated ?
                  <>
                    <Route path="/myOrders" component={Orders} exact />
                    <Route path="/viewOrder" component={ViewOrderDetails} exact />
                    <Route path="/myStudents" component={MyStudents} exact />
                    {/* <Route path="/profile" component={Profile} exact /> */}
                  </>
                  : ''}
            </Switch>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: getisAuthenticated(state)
  }
}


export default connect(mapStateToProps)(App);
